import React from 'react';
import { Divider, Menu } from 'antd';
import { Link } from 'react-router-dom';
import UserStore from '../../stores/UserStore';
import { useHistory } from 'react-router';
import CurrentUser from '../../User/CurrentUser';
import { LogoutOutlined, QuestionCircleOutlined } from '@ant-design/icons';

const UserMenu = () => {
    const history = useHistory();
    return (
        <Menu>
            <Menu.Item key="user">
                <Link to="/my-account/settings">
                    <CurrentUser
                        fullName={UserStore.defaultContactName ?? UserStore.user?.email ?? ''}
                        companyName={UserStore.defaultAccountName ?? UserStore.user?.company}
                        email={UserStore.user?.email}
                    />
                </Link>
            </Menu.Item>

            <Divider className="mx-0 my-1 p-0" />

            <Menu.Item key="support" icon={<QuestionCircleOutlined className="font-size-base" />}>
                <Link to="/my-account/support">Help & Support</Link>
            </Menu.Item>
            <Menu.Item
                key="logout"
                onClick={() => {
                    // UserStore.logout already shows the failure message.
                    UserStore.logout()
                        .then(() => history.push('/'))
                        .catch(() => undefined);
                }}
                icon={<LogoutOutlined className="font-size-base" />}
            >
                Logout
            </Menu.Item>
        </Menu>
    );
};

export default UserMenu;
